module.exports = __webpack_public_path__ + "media/images/design/sizeK-7e885097dcb00a689b60388ddd6270bc.png";